"use client";

import { Box, Typography } from "@mui/material";

export function UserAgreementPage() {
  return (
    <Box
      sx={(theme) => ({
        backgroundColor: "white",
        maxWidth: "800px",
        margin: "0 auto",
        padding: 2,
        h4: theme.typography.h4,
        "& p": {
          ...theme.typography.body1,
          margin: theme.spacing(1, 0),
        },
        ul: {
          ...theme.typography.body1,
          paddingLeft: theme.spacing(4),
          marginBottom: theme.spacing(2),
        },
      })}
    >
      <Typography variant="h4" component="h1">
        User Agreement
      </Typography>

      <p>
        Horsezone is a registered business name of Niche Digital Ventures Pty
        Ltd (ACN&nbsp;681 461 807) (&quot;us&quot; or &quot;we&quot;)
      </p>
      <p>
        This Agreement between you and us describes the terms and conditions for
        your use of the Horsezone website http://www.horsezone.com.au
        (&quot;Website&quot;) and the services available on our Website.&nbsp;This
        Agreement applies to registered members as well as browsers of our
        Website who are not registered members.
      </p>
      <p>
        By registering as a member of our Website or continuing to browse our
        Website, you are agreeing to comply with and be bound by the following
        terms and conditions of use, which together with our policies including
        our Privacy Policy, govern Horsezone&apos;s relationship with you.
      </p>
      <p>1.&nbsp;Membership</p>
      <p>
        To register as a member of our Website, you must be a natural person.
      </p>
      <p>2.&nbsp;Nature of activities on our Website</p>
      <p>
        You acknowledge that, although some items on our Website may be listed
        in an auction-style format, Horsezone is not a traditional &quot;auctioneer&quot;
        and is not involved in any transactions between you and other members of
        our Website.&nbsp;Our Website is simply a forum for the distribution and
        publication of information about horses and related items which are
        available for sale and allows you to enter into transactions with other
        members of our Website.
      </p>
      <p>3.&nbsp;No warranties</p>
      <p>
        The information and content contained on our Website is provided &quot;as is&quot;
        and neither we, nor any third parties, provide any warranty or guarantee
        as to:
      </p>
      <p>
        (a)&nbsp;the title, quality, condition, safety, merchantability,
        legality or suitability for any particular purpose of any horses or
        related items listed for sale on our Website;
      </p>
      <p>
        (b)&nbsp;the accuracy, timeliness, performance, completeness or
        suitability of any information or content contained on our Website;
      </p>
      <p>
        (c)&nbsp;the ability of members to complete a transaction entered into
        with you; or
      </p>
      <p>
        (d)&nbsp;the ability of members to act in accordance with this Agreement
        or lawfully in using our Website.
      </p>
      <p>4.&nbsp;Your use of our Website</p>
      <p>4.1&nbsp;Use at own risk</p>
      <p>
        You acknowledge that any information or content on our Website may
        contain inaccuracies or errors and that your use of our Website is
        entirely at your own risk.
      </p>
      <p>4.2&nbsp;Your responsibilities</p>
      <p>You agree that you are solely responsible for:</p>
      <p>
        (a)&nbsp;investigating quality, condition, safety, merchantability,
        legality or suitability for any particular purpose of any horses or
        related items listed for sale on our Website;
      </p>
      <p>
        (b)&nbsp;verifying the truth, accuracy or completeness of any
        information or content contained on our Website or provided to you by
        other users of our Website before relying on it; and
      </p>
      <p>
        (c)&nbsp;ensuring that your listing, selling, bidding, buying and other
        activities conducted on our Website are lawful; and
      </p>
      <p>agree that you will not:</p>
      <p>
        (d)&nbsp;use any robot, spider, scraper or other automated means to
        access our Website for any purpose without our prior written consent;
      </p>
      <p>
        (e)&nbsp;take any action that imposes, or may impose, an unreasonable or
        disproportionately large load on our Website or infrastructure;
      </p>
      <p>
        (f)&nbsp;interfere or attempt to interfere with the proper working of
        our Website or any activities conducted on our Website;
      </p>
      <p>
        (g)&nbsp;bypass our robot exclusion headers or other measures we may use
        to prevent or restrict access to our Website; or
      </p>
      <p>
        (h)&nbsp;use our Website in a manner that is not lawful or in our
        reasonable opinion, unacceptable, or provide us with false information.
      </p>
      <p>4.3&nbsp;Linking</p>
      <p>
        Creating a link to our Website from another website or document,
        including deep linking to parts of our Website, is prohibited without
        our prior written consent.
      </p>
      <p>4.4 Age qualification</p>
      <p>
        To use our Website, whether creating a listing, posting a comment, or
        bidding or buying an item listed for sale, you must be either at least
        18 years of age or, if you are under 18 years of age, you must have the
        permission of a parent or guardian.
      </p>
      <p>5.&nbsp;Your listings and other content posted by you</p>
      <p>5.1&nbsp;Types of items and listings</p>
      <p>
        (a)&nbsp;Only horses or related items may be listed on our Website for
        sale.&nbsp;Horses may only be listed for sale as a classified
        listing.&nbsp;Related items may be listed for sale as a classified
        listing or an auction listing.
      </p>
      <p>(b)&nbsp;Auction listings may be in 3 different formats:</p>
      <p>(1)&nbsp;an online auction listing;</p>
      <p>
        (2)&nbsp;a fixed price “buy now” listing, with no bidding allowed; or
      </p>
      <p>
        (3)&nbsp;an online auction listing with a “buy now” option, which allows
        members to choose whether to buy your item at a fixed “buy now” price or
        to bid in the auction.
      </p>
      <p>5.2&nbsp;Creating a listing and posting content</p>
      <p>(a)&nbsp;You must:</p>
      <p>
        (1)&nbsp;be a member of our Website to create a listing or to post
        content on our Website;
      </p>
      <p>
        (2)&nbsp;be legally able to sell any horse or related item that you list
        for sale on our Website; and
      </p>
      <p>
        (3)&nbsp;be prepared and willing to sell the horse or related item at
        the time of listing.
      </p>
      <p>
        (b)&nbsp;You must not list a horse or related item which you are unable
        to or do not intend to sell.
      </p>
      <p>
        (c)&nbsp;When listing your horse or related item for sale on our
        Website, your listing must:
      </p>
      <p>(1)&nbsp;describe your horse or related item fully and accurately;</p>
      <p>(2)&nbsp;be listed in an appropriate category;</p>
      <p>
        (3)&nbsp;include all terms of sale which must be stated fully and
        accurately; and
      </p>
      <p>
        (4)&nbsp;include the price for the horse or related item. Where GST is
        applicable, the listed price must be inclusive of GST and GST cannot be
        charged to the buyer as an additional cost on top of the listed price or
        winning bid.
      </p>
      <p>
        (d)&nbsp;Your listing, and any other content that you post on our
        Website, must not:
      </p>
      <p>
        (1)&nbsp;infringe any third party&apos;s copyright, trademark, privacy,
        confidentiality or other intellectual property rights;
      </p>
      <p>(2)&nbsp;be false, misleading or deceptive;</p>
      <p>(3)&nbsp;breach any applicable laws;</p>
      <p>
        (4)&nbsp;be offensive, obscene, inappropriate, defamatory, libellous,
        threatening or harassing;
      </p>
      <p>
        (5)&nbsp;contain any malicious code or data which causes harm or
        disrupts the intended functioning of our Website; or
      </p>
      <p>
        (6)&nbsp;make any reference or contain any hyperlinks to any
        organisation or website that provides services to offer, sell, bid for
        or buy goods.
      </p>
      <p>5.3&nbsp;Our right to refuse, remove or alter listings or content</p>
      <p>
        (a)&nbsp;We may refuse, remove or alter any information you provide to
        us including your listing and any content that you post on our Website,
        if we:
      </p>
      <p>
        (1)&nbsp;reasonably believe that it breaches the terms of this
        Agreement; or
      </p>
      <p>(2)&nbsp;are instructed to do so by any third party.</p>
      <p>
        (b)&nbsp;We reserve the right to determine the duration of your listing,
        change the nominated category of your listing or remove your
        listing.
      </p>
      <p>
        (c)&nbsp;If, as a result of our alteration or removal of your listing,
        the cost of your listing is lower than the listing fee paid by you, we
        will refund you the difference except where we have altered or removed
        your listing as a result of a breach of this Agreement by you.
      </p>
      <p>5.4&nbsp;Grant of licence </p>
      <p>
        To the extent that you have any intellectual property rights in your
        listing and any content that you post on our Website, you grant us a
        royalty-free and irrevocable licence to use, reproduce, modify, adapt
        and sub-licence your listing and any content that you post on our
        Website.
      </p>
      <p>5.5&nbsp;Auction listings</p>
      <p>If your item is listed for sale as an auction listing:</p>
      <p>
        (a)&nbsp;an online auction starts when your listing is submitted,
        although there may be a delay from the time the listing is submitted by
        you to the time that it will be visible to members on our Website; and
      </p>
      <p>
        (b)&nbsp;you must complete the transaction with the bidder with the
        highest bid above your reserve price (if any) at the end of the online
        auction, or in the case of a listing with a “buy now” option, the buyer
        of the item unless:
      </p>
      <p>
        (1)&nbsp;the buyer fails to meet your terms of sale as describing in
        your listing; or
      </p>
      <p>(2)&nbsp;you are unable to authenticate the buyer&apos;s identity</p>
      <p>6.&nbsp;Bidding and buying</p>
      <p>
        (a)&nbsp;You must be a member of our Website in order to bid on any item
        listed for sale as an auction listing.
      </p>
      <p>
        (b)&nbsp;When you bid for an item in an auction listing (or in the case
        of a listing with a &quot;buy now&quot; option, when you buy the item), you agree
        with the seller to the terms of sale for that item as described by the
        seller in the listing.
      </p>
      <p>
        (c)&nbsp;If you are the successful bidder of an item of an auction
        listing (or in the case of a listing with a &quot;buy now&quot; option, you are
        the buyer of the item), you are committed to buying that item on the
        seller&apos;s terms of sale and must complete the transaction with the seller
        unless:
      </p>
      <p>
        (1)&nbsp;the transaction is illegal or in breach of this Agreement; or
      </p>
      <p>(2)&nbsp;you are able to retract your bid and do so.</p>
      <p>
        (e)&nbsp;If you fail to complete a transaction, you will be in breach of
        your obligations to Horsezone and the seller and you may be liable to
        each.
      </p>
      <p>7.&nbsp;Fees</p>
      <p>7.1&nbsp;Listing fees</p>
      <p>
        (a)&nbsp;When you list a horse or related item for sale on our Website,
        you must pay a listing fee to Horsezone.&nbsp;The applicable listing
        fees are as <a href="http://www.horsezone.com.au/pricing">follows</a>
      </p>

      <p>
        (b)&nbsp;You will be charged the listing fees at the time you list your
        item for sale on our Website and these fees will be debited from your
        account balance automatically.&nbsp;
      </p>
      <p>
        (c)&nbsp;When listing a horse or related item for sale on our Website,
        you will presented with an option to direct us to pay 10 percent of the
        applicable listing fee to a club registered on our Website as
        sponsorship. If you select a club, we will pay 10 percent of the
        applicable listing fee to the registered club in accordance with our
        Clubs Policy
      </p>
      <p>7.2&nbsp;Additional fees to “feature” listing </p>
      <p>
        (a)&nbsp;At the time of listing your horse or related item for sale on
        our Website or at any time during the duration of your listing, you may
        wish to “feature” your listing so that it will appear on the home page
        of our Website as well as appearing higher up in search results on our
        Website.
      </p>
      <p>
        (b)&nbsp;If you “feature” your listing, you must additional fees as
        <a href="http://www.horsezone.com.au/pricing">follows</a>
      </p>

      <p>
        (c)&nbsp;You will be charged the additional fees to &quot;feature&quot; your
        listing at the time of adding the &quot;feature&quot; to your listing and these
        fees will be debited from your account balance automatically.&nbsp;
      </p>
      <p>7.3&nbsp;Final value fees</p>
      <p>
        (a)&nbsp;If you sell an item for sale under an auction listing, you must
        pay a final value fee to Horsezone.&nbsp;The applicable final value fee
        will be 3% of the sale price of your item (that is, final value of your
        listing).
      </p>
      <p>
        (b)&nbsp;If the item is sold, you will be charged the final value fees
        at the end of the auction and these fees will be debited from your
        account balance automatically at the end of the auction.&nbsp;
      </p>
      <p>7.4&nbsp;Fees not transferable to buyer</p>
      <p>
        All fees relating to listings are to be paid by you as the seller. If
        you are a seller, you are not permitted to transfer any of the fees
        relating to listings to the buyer by adding an extra fee to the final
        winning bid amount or sale price.
      </p>
      <p>7.5&nbsp;Tax invoice</p>
      <p>
        We will issue a tax invoice to you for our fees.&nbsp;If our account is
        not paid within 30 days, we may terminate your membership forthwith by
        notice to you via email.
      </p>
      <p>7.6&nbsp;Account balance</p>
      <p>
        If your account balance is negative, you will not be permitted to list
        any items until your account balance is brought back to at least $0.
      </p>
      <p>7.7&nbsp;Variation to fees</p>
      <p>
        We may vary our fees from time and time and the new fees will appear on
        our Website.&nbsp;Our new fees will not take effect until 30 days from
        the date that they are posted on our Website.
      </p>
      <p>9.&nbsp;Breach</p>
      <p>If :</p>
      <p>
        (a)&nbsp;you commit a breach of this Agreement which is not capable of
        being remedied;
      </p>
      <p>
        (b)&nbsp;you commit a breach of this Agreement which is capable of being
        remedied but fail to remedy the breach within the time frame specified
        in our notice of the breach to you;
      </p>
      <p>(c)&nbsp;your account balance is negative for 30 days or more;</p>
      <p>
        (d)&nbsp;we reasonably believe that your actions may cause loss or
        damage to us or a third party;
      </p>
      <p>(e)&nbsp;the law requires us to do so; or</p>
      <p>
        (f)&nbsp;we receive a serious complaint or multiple complaints regarding
        your membership;
      </p>
      <p>we may, in our sole discretion and without notice to you :</p>
      <p>
        (g)&nbsp;refuse to show, or delay showing, your listings or content on
        our Website;
      </p>
      <p>
        (h)&nbsp;cancel your listings or remove your content from our Website;
        and
      </p>
      <p>
        (i)&nbsp;suspend, terminate or limit your membership or your access to
        our Website.
      </p>
      <p>10.&nbsp;Termination</p>
      <p>10.1&nbsp;Termination without cause</p>
      <p>
        Notwithstanding any other term of this Agreement, you or Horsezone may
        terminate this Agreement at any time by giving 30 days&apos; written notice
        to the other party via email.
      </p>
      <p>10.2&nbsp;Consequences of termination</p>
      <p>Termination of this Agreement will result in:</p>
      <p>
        (a)&nbsp;cancellation of your membership and refund of your account
        balance (if any);
      </p>
      <p>(b)&nbsp;cancellation of your listings (if any);</p>
      <p>
        (c)&nbsp;removal of your content posted on our Website (if any); and
      </p>
      <p>(d)&nbsp;refusal of any subsequent registrations by you.</p>
      <p>11.&nbsp;Liability and indemnity</p>
      <p>
        (a)&nbsp;To the extent permitted by law, Horsezone is not liable to you
        for any loss, damage or liability arising out of or in connection with
        our services or Website, including, but not limited to:
      </p>
      <p>
        (1)&nbsp;loss of profits or any special, indirect, incidental or
        consequential loss;
      </p>
      <p>
        (2)&nbsp;any loss arising out of or in connection with any transaction
        between you and other members of the Website;
      </p>
      <p>
        (3)&nbsp;loss caused by our failure to comply with our obligations under
        this Agreement where that loss is caused by events outside our
        reasonable control such as interrupted access to our Website.
      </p>
      <p>
        (b)&nbsp;Where Horsezone&apos;s liability cannot be excluded, it is limited
        to:
      </p>
      <p>(1)&nbsp;for goods:</p>
      <p>(A)&nbsp;the cost of replacing the goods;</p>
      <p>(B)&nbsp;the cost of obtaining equivalent goods; or</p>
      <p>(C)&nbsp;the cost of having the goods repaired,</p>
      <p>whichever is the lowest; and</p>
      <p>(2)&nbsp;for services, the cost of providing those services.</p>
      <p>
        (c)&nbsp;You release us from all claims, damages and liabilities
        (including indirect and consequential loss) arising out of or in
        connection with any transaction between you and other members of the
        Website.
      </p>
      <p>
        (d)&nbsp;You indemnify us and our officers, directors, agents and
        employees against all claims, demands, losses and damages caused by or
        arising out of your use of our Website.
      </p>
      <p>12.&nbsp;Notice</p>
      <p>
        Any notices in relation to this Agreement must be given by
        email.&nbsp;In the case of Horsezone, the email address for service of
        notices is support@horsezone.com.au. In your case, the email address in
        your account details with us (being the email address provided by you to
        Horsezone during the registration process as changed by you from time to
        time).
      </p>
      <p>13.&nbsp;General</p>
      <p>13.1&nbsp;Website</p>
      <p>
        (a)&nbsp;We do not guarantee continuous, uninterrupted or secure access
        to our services on our Website and the operation of our Website may be
        interfered with from time to time by numerous factors outside of our
        control.
      </p>
      <p>
        (b)&nbsp;The content of the pages of our Website is for your general
        information and use only. It is subject to change without notice.
      </p>
      <p>
        (c)&nbsp;Unauthorised use of our website may give to a claim for damages
        and/or be a criminal offence.
      </p>
      <p>13.2&nbsp;Intellectual property</p>
      <p>
        Our Website contains material which is either owned by or licensed to
        us. This material includes, but is not limited to, the design, layout,
        look, appearance and graphics. Reproduction is prohibited other than in
        accordance with the copyright notice, which forms part of this
        Agreement.
      </p>
      <p>13.3&nbsp;Other websites</p>
      <p>
        Our Website may include links to other websites from time to time. These
        links are provided for your convenience to provide further information
        and do not signify that we endorse the website(s). We have no
        responsibility for the content of the linked website(s).
      </p>
      <p>13.4&nbsp;Severance</p>
      <p>
        If any provision of this Agreement is void, illegal or unenforceable, it
        may be severed without affecting the other provisions in this Agreement.
      </p>
      <p>13.5&nbsp;No waiver</p>
      <p>
        Our failure to act with respect to a breach by you or others does not
        waive our right to act with respect to subsequent or similar
        breaches.
      </p>
      <p>13.6&nbsp;Assignment</p>
      <p>
        You agree that this Agreement may be assigned by us in the event of a
        sale or other transfer of Horsezone or any part of Horsezone.
      </p>
      <p>13.7&nbsp;Entire agreement</p>
      <p>
        This Agreement replaces all previous agreements about its subject matter
        and constitutes the entire agreement between you and us.
      </p>
      <p>13.8&nbsp;Survival</p>
      <p>
        The terms of this Agreement survive its termination to the extent
        permitted by law.
      </p>
      <p>13.9&nbsp;Jurisdiction and governing law</p>
      <p>
        This Agreement is made in the state of New South Wales, Australia and is
        governed by the laws of New South Wales, Australia.&nbsp;Your use of our
        Website and any dispute arising out of such use of our Website is
        subject to the laws of the Commonwealth of Australia and New South Wales
      </p>
      <p>&nbsp;</p>

      <Typography variant="h4" component="h1">
        Terms & Conditions
      </Typography>

      <p>
        Welcome to our website. If you continue to browse and use this website
        you are agreeing to comply with and be bound by the following terms and
        conditions of use, which together with our privacy policy govern
        Horsezone.com.au&apos;s relationship with you, in relation to this website.
      </p>
      <p>
        Horsezone.com.au refers to the owner of the website. The term ‘you&apos;
        refers to the user or viewer of our website.
      </p>
      <p>The use of this website is subject to the following terms of use:</p>
      <p>
        The content of the pages of this website is for your general information
        and use only. It is subject to change without notice.
      </p>
      <p>
        Neither we nor any third parties provide any warranty or guarantee as to
        the accuracy, timeliness, performance, completeness or suitability of
        the information and materials found or offered on this website for any
        particular purpose. You acknowledge that such information and materials
        may contain inaccuracies or errors and we expressly exclude liability
        for any such inaccuracies or errors to the fullest extent permitted by
        law.
      </p>
      <p>
        Your use of any information or materials on this website is entirely at
        your own risk, for which we shall not be liable. It shall be your own
        responsibility to ensure that any products, services or information
        available through this website meet your specific requirements.
      </p>
      <p>
        This website contains material which is owned by or licensed to us. This
        material includes, but is not limited to, the design, layout, look,
        appearance and graphics. Reproduction is prohibited other than in
        accordance with the copyright notice, which forms part of these terms
        and conditions.
      </p>
      <p>
        All trademarks reproduced in this website, which are not the property
        of, or licensed to the operator, are acknowledged on the website.
      </p>
      <p>
        Unauthorised use of this website may give to a claim for damages and/or
        be a criminal offence.
      </p>
      <p>
        From time to time this website may also include links to other websites.
        These links are provided for your convenience to provide further
        information. They do not signify that we endorse the website(s). We have
        no responsibility for the content of the linked website(s).
      </p>
      <p>
        You may not create a link to this website from another website or
        document without the prior written consent of Horsezone.com.au.
      </p>
      <p>
        Your use of this website and any dispute arising out of such use of the
        website is subject to the laws of the Commonwealth of Australia and New
        South Wales
      </p>
    </Box>
  );
}
